import { render } from "./CoinbaseBoard.vue?vue&type=template&id=3f933945"
import script from "./CoinbaseBoard.vue?vue&type=script&lang=js"
export * from "./CoinbaseBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__